export default function getQueryParam(paramName, url = window.location.search) {
  // Remove the leading '?' from the URL string if present
  const queryString = url.split('?')[1];
  let res = null

  if (queryString) {
    // Split the query string into individual parameters
    const params = queryString.split('&');
    
    // Find the parameter we're looking for
    const paramValue = params.find(p => p.startsWith(paramName + '='));
    
    if (paramValue) {
      res = decodeURIComponent(paramValue.split('=')[1])
    } 
    return res
  }
  return res
}